import * as React from 'react';

interface IButtonGroupContext {
  variant?: 'solid' | 'outline' | 'ghost';
  color?: 'primary' | 'neutral';
  weight?: 'normal' | 'bold';
  disabled?: boolean;
}

/**
 * @ignore - internal component.
 */
const ButtonGroupContext = React.createContext<IButtonGroupContext>({});

/*
 * We will modify the displayName on !== Production to ButtonGroupContext
 * so we can easily search for the provider on React DevTools.
 * This will change the element name from:
 *  Context.Provider -> ButtonGroupContext.Provider
 */
if (process.env.NODE_ENV !== 'production') {
  ButtonGroupContext.displayName = 'ButtonGroupContext';
}

export default ButtonGroupContext;
